import { ShoppingListIngredientDetail } from "@/clients/models/ShoppingListIngredientDetail";
import { memo, useMemo } from "react";
import { ShoppingListItem } from "../shopping-list-item";

interface ShoppingListProps {
  selectedIngredients: ShoppingListIngredientDetail[];
  tickedItems: Set<string>;
  handleToggleItem: (ingredientId: string) => () => void;
}

const ShoppingList = memo(function ShoppingList({
  selectedIngredients,
  tickedItems,
  handleToggleItem,
}: ShoppingListProps) {
  const tickedIngredients = useMemo(
    () => selectedIngredients.filter((ingredient) => tickedItems.has(ingredient.ingredientId)),
    [selectedIngredients, tickedItems],
  );
  const untickedIngredients = useMemo(
    () => selectedIngredients.filter((ingredient) => !tickedItems.has(ingredient.ingredientId)),
    [selectedIngredients, tickedItems],
  );

  return (
    <div className="flex w-full flex-col gap-8">
      {untickedIngredients?.map((ingredient) => {
        return (
          <ShoppingListItem
            key={ingredient.ingredientId}
            ingredientId={ingredient.ingredientId}
            ingredientName={ingredient.ingredientName}
            isTicked={false}
            onToggle={handleToggleItem(ingredient.ingredientId)}
          />
        );
      })}
      {tickedIngredients?.map((ingredient) => {
        return (
          <ShoppingListItem
            key={ingredient.ingredientId}
            ingredientId={ingredient.ingredientId}
            ingredientName={ingredient.ingredientName}
            isTicked={true}
            onToggle={handleToggleItem(ingredient.ingredientId)}
          />
        );
      })}
    </div>
  );
});

export default ShoppingList;
